export const NUDOS_CARE_ID = {
  FREE: 1,
  BASIC: 2,
  LOG: 3,
  FULL: 4,
} as const;
export type TNudosCareId = typeof NUDOS_CARE_ID[keyof typeof NUDOS_CARE_ID];

export const NUDOS_CARE_NAME = {
  FREE: 'Free',
  BASIC: 'Basic',
  LOG: 'Log',
  FULL: 'Full',
} as const;
export type TNudosCareName = typeof NUDOS_CARE_NAME[keyof typeof NUDOS_CARE_NAME];
